<template>
  <section
    id="rhinoplasty"
  >
    <v-container mt-5>
      <v-layout>
        <v-flex>
          <h1>Rhinoplasty</h1>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
  })
}
</script>
